<script setup lang="ts">
// No props or emits needed for this simple component
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

const { t } = useI18n();
</script>

<template>
  <div class="text-center">
    <!-- PayJoy logo animation -->
    <div class="logo-container mb-4">
      <img
        :src="`${useAsset('img/offers/assets/payjoy-icon.svg')}`"
        alt="PayJoy"
        class="loading-logo"
      />
    </div>

    <!-- Status text -->
    <h2 class="preparing-text">{{ t("PREPARING_OFFERS") }}</h2>
  </div>
</template>

<style scoped>
.logo-container {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  position: relative;
}

.loading-logo {
  width: 100%;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
    transform: scale(0.98) translateY(5px);
  }
  50% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.98) translateY(5px);
  }
}

.preparing-text {
  color: #0b8457;
  font-size: 24px;
  font-weight: 500;
}
</style>
